import {onDomReady} from "../../components/dynamic/observer";
import {FreeMode, Navigation, Swiper} from 'swiper';
import '../../../node_modules/swiper/swiper.scss';

function init() {
    document.querySelectorAll('[data-product-slider-container]')
        .forEach((el) => {
            const slider = new Swiper(el.querySelector('[data-product-slider]'), {
                modules: [Navigation, FreeMode],
                spaceBetween: 14,
                speed: 700,
                navigation: {
                    prevEl: el.querySelector('[data-product-slider-left]'),
                    nextEl: el.querySelector('[data-product-slider-right]'),
                },
                breakpoints: {
                    0: {
                        loop: false,
                        freeMode: true,
                        slidesPerView: 2,
                        spaceBetween: 11,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                    1400: {
                        slidesPerView: 5,
                    },
                },
                on: {
                    init: function (swiper) {
                        if (window.innerWidth >= swiper.currentBreakpoint) {
                            if (swiper.slides.length <= swiper.params.slidesPerView) {
                                swiper.navigation.prevEl.parentElement.classList.add('_hidden');
                            }
                        }
                    },
                }
            });
        })
}

onDomReady(init);